import { render, staticRenderFns } from "./PaymentChange.vue?vue&type=template&id=2f51eb8a&scoped=true&"
import script from "./PaymentChange.vue?vue&type=script&lang=ts&"
export * from "./PaymentChange.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentChange.vue?vue&type=style&index=0&id=2f51eb8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f51eb8a",
  null
  
)

export default component.exports